import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { StatIconName } from '../stat.model';
import {
  ContractDeveloperIconComponent,
  ArrowLeftIconComponent,
  DollarValueIconComponent,
  EditSquareIconComponent,
  ForbiddenIconComponent,
  InfoIconComponent,
  TickSquareIconComponent,
  UserIconComponent,
  ClockIconComponent,
  AllIconComponent,
  MultiUsersIconComponent,
  InboxIconComponent,
  DocumentIconComponent,
  TimerStartIconComponent,
  TaskViewIconComponent,
  TickIconComponent,
  CloseIconComponent,
  RemainingIconComponent,
  InprogressIconComponent,
  HoldIconComponent,
} from '@kuiper/icons';

@Component({
  selector: 'lib-stat-icons',
  imports: [
    ContractDeveloperIconComponent,
    ArrowLeftIconComponent,
    DollarValueIconComponent,
    EditSquareIconComponent,
    ForbiddenIconComponent,
    InfoIconComponent,
    TickSquareIconComponent,
    UserIconComponent,
    ClockIconComponent,
    AllIconComponent,
    MultiUsersIconComponent,
    InboxIconComponent,
    DocumentIconComponent,
    TimerStartIconComponent,
    TaskViewIconComponent,
    TickIconComponent,
    CloseIconComponent,
    RemainingIconComponent,
    InprogressIconComponent,
    HoldIconComponent,
  ],
  templateUrl: './stat-icons.component.html',
  styleUrl: './stat-icons.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class StatIconsComponent {
  iconName = input<StatIconName>('info');
}
